import { LocalStorageKey } from '@/modules/core/app/constants/app.constants';
import { LocalStorage } from '@/modules/core/app/helpers/LocalStorage';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import DeviceService from '@/modules/core/ui/services/DeviceService';

export class ClientSessionPreferenceService extends BaseService {
  private storage(): LocalStorage {
    return new LocalStorage();
  }

  shouldShowUnsupportedMobileViewWarningModal(): boolean {
    if (!DeviceService.isMobile()) {
      return false;
    }

    return !this.hasDismissedUnsupportedMobileViewWarning();
  }

  hasDismissedUnsupportedMobileViewWarning(): boolean {
    try {
      return (
        this.storage().getItem(LocalStorageKey.UNSUPPORTED_MOBILE_VIEW_WARNING_DISMISSED) === 'true'
      );
    } catch {
      return false;
    }
  }

  setDismissedUnsupportedMobileViewWarning(): void {
    try {
      this.storage().setItem(LocalStorageKey.UNSUPPORTED_MOBILE_VIEW_WARNING_DISMISSED, 'true');
    } catch {
      // quota / private mode / blocked storage
    }
  }

  clearUnsupportedMobileViewWarningLocalStorage(): void {
    try {
      this.storage().removeItem(LocalStorageKey.UNSUPPORTED_MOBILE_VIEW_WARNING_DISMISSED);
    } catch {
      // ignore
    }
  }
}

export default new ClientSessionPreferenceService();
